import CommonMixin from '@/mixins/templates/common.js';
import equalWebMixin from '@/mixins/equal-web';
import GenericModal from '@/components/ui/generic-modal';
import OpenNewTabMixin from '@/mixins/open-new-tab';

export default {
  name       : 'modalContentTypeHtml',
  mixins     : [CommonMixin, equalWebMixin, OpenNewTabMixin],
  components : { GenericModal },
  data() {
    return {
      isOpen            : false,
      title             : '',
      linkLti           : '',
      accessibilityText : '',
      showEqualwebAlert : true,
      genericModal      : {
        showModal           : false,
        title               : this.$t('common.attention'),
        text                : this.$t('ltiRender.accessibilityAlertText'),
        textSecondaryButton : this.$t('common.cancel'),
        textPrimaryButton   : this.$t('ltiRender.accessibilityAlertConfirmBtn')
      }
    };
  },
  mounted() {
    this.$nuxt.$on('isOpenContentModalLti', ({ link, title, accessibilityText }) => {
      this.linkLti = link;
      this.title = title;
      this.accessibilityText = accessibilityText;
      this.isOpen = !this.isOpen;
    });
  },
  watch: {
    isEqualWebMenuOpen(newValue) {
      if (this.isOpen && newValue && this.showEqualwebAlert) {
        this.genericModal.showModal = true;
      }
    }
  },
  methods: {
    closeModal() {
      this.isOpen = !this.isOpen;
      this.title = '';
      this.linkLti = '';
      this.accessibilityText = '';
      this.showEqualwebAlert = true;
    },
    handleConfirm() {
      this.openUrlInNewTab(this.linkLti);
      this.closeModal();
      this.genericModal.showModal = false;
      this.showEqualwebAlert = false;
    },
    handleCancel() {
      this.genericModal.showModal = false;
      this.showEqualwebAlert = false;
    }
  },
  beforeDestroy() {
    this.$nuxt.$off();
  }
};
